/* Ameya: Buy now + Add to Cart on card grids, Notify me on sold-out cards, floating View cart, instant checkout after Buy now */
(function () {
  if (window.__ameyaEnhance) { return; }
  window.__ameyaEnhance = true;

  // Sold-out cards: one "Notify me" button instead of Add to cart + Buy now
  try {
    var nst = document.createElement('style');
    nst.textContent = '.ameya-cardnotify{display:flex;align-items:center;justify-content:center;text-decoration:none;cursor:pointer;text-align:center}.ameya-card:has(button[data-soldout]) .ameya-cardbuy{display:none}';
    document.head.appendChild(nst);
  } catch (e) {}

  var parts = location.pathname.split('/').filter(Boolean);
  var isCart = parts.length === 1 && parts[0] === 'cart';
  var isCheckout = parts.indexOf('checkouts') > -1;
  var fab = null;

  function setCount(n, total) {
    document.querySelectorAll('[data-ameya-cartcount]').forEach(function (b) {
      b.textContent = n > 99 ? '99+' : String(n);
      b.classList.toggle('is-hidden', !n);
    });
    if (!fab) { return; }
    var prev = parseInt(fab.getAttribute('data-count') || '0', 10);
    fab.setAttribute('data-count', String(n));
    fab.querySelector('.ameya-cartfab__count').textContent = String(n);
    fab.title = n ? ('View cart (' + n + (n === 1 ? ' item' : ' items') + ', Rs. ' + (total / 100).toFixed(2) + ')') : 'View cart';
    if (n !== prev) { fab.classList.remove('is-bump'); void fab.offsetWidth; fab.classList.add('is-bump'); }
  }

  function refresh() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count, c.total_price); return c; })
      .catch(function () { return null; });
  }

  function buildFab() {
    if (isCart || isCheckout || document.querySelector('.ameya-cartfab')) { return; }
    fab = document.createElement('a');
    fab.className = 'ameya-cartfab';
    fab.href = '/cart';
    fab.setAttribute('aria-label', 'View cart');
    fab.setAttribute('data-count', '0');
    fab.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7h12l-1 13H7L6 7z"></path><path d="M9 7a3 3 0 0 1 6 0"></path></svg><span class="ameya-cartfab__label">View cart</span><span class="ameya-cartfab__count">0</span>';
    document.body.appendChild(fab);
    refresh();
  }

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input) {
      var p = nativeFetch.apply(this, arguments);
      try {
        var u = typeof input === 'string' ? input : ((input && input.url) || '');
        if (u.indexOf('/cart/add') > -1 || u.indexOf('/cart/change') > -1 || u.indexOf('/cart/update') > -1 || u.indexOf('/cart/clear') > -1) {
          p.then(function () { setTimeout(refresh, 200); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  function drawerEl() { return document.getElementById('cart-drawer'); }

  function openDrawer() {
    var d = drawerEl();
    if (isCart || !d || typeof d.open !== 'function') { return false; }
    if (!d.hasAttribute('open')) { d.open(); }
    return true;
  }

  function addPlain(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { throw new Error(j.description || 'add failed'); }
        return j;
      });
    });
  }

  // Normal adds go through the theme's own cart action so the slide-in cart updates and opens.
  // Buy now (quiet) uses the plain add so nothing flashes before checkout.
  function addToCart(id, quiet) {
    var act = window.Shopify && Shopify.actions && Shopify.actions.updateCart;
    var d = drawerEl();
    if (quiet || isCart || !act || !d || typeof d.open !== 'function') { return addPlain(id); }
    return act({ lines: [{ merchandiseId: String(id), quantity: 1 }] }).then(function (res) {
      var errs = res && res.userErrors;
      if (errs && errs.length) { throw new Error(errs[0].message || 'add failed'); }
      return res;
    });
  }

  function inCart(id) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c.items.some(function (i) { return String(i.variant_id) === String(id); }); })
      .catch(function () { return false; });
  }

  function goCheckout() {
    try { sessionStorage.setItem('ameya_autocheckout', String(Date.now())); } catch (e) {}
    location.href = '/cart';
  }

  function run(btn, id, isBuy) {
    if (!id || btn.disabled) { return; }
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = isBuy ? 'Opening...' : 'Adding...';
    addToCart(id, isBuy).then(function (res) {
      if (isBuy) { goCheckout(); return; }
      btn.textContent = (res && res.warnings && res.warnings.length) ? 'Already in cart' : 'Added to cart';
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1700);
    }).catch(function () {
      inCart(id).then(function (yes) {
        if (isBuy && yes) { goCheckout(); return; }
        btn.textContent = yes ? 'Already in cart' : 'Try again';
        if (yes) { openDrawer(); }
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
      });
    });
  }

  function mk(text, cls) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.textContent = text;
    return b;
  }

  // Go to the product page, where the Notify me email box is
  function gotoNotify(href) {
    var base = String(href || '').split('#')[0].split('?')[0];
    if (!base) { return; }
    location.href = base + '#notify';
  }

  function enhanceRails() {
    document.querySelectorAll('.ameya-card').forEach(function (card) {
      if (card.getAttribute('data-ameya')) { return; }
      var form = card.querySelector('form[action*="/cart/add"]');
      if (!form) { return; }
      var input = form.querySelector('[data-card-atc-input]') || form.querySelector('input[name=id]');
      var atc = form.querySelector('button[type=submit]');
      if (!input || !atc) { return; }
      card.setAttribute('data-ameya', '1');
      var cardLink = card.querySelector('[data-card-link]') || card.querySelector('a[href*="/products/"]');
      var buy = mk('Buy now', 'ameya-btn ameya-btn--outline ameya-cardbuy');
      if (atc.disabled) { buy.disabled = true; }
      atc.insertAdjacentElement('afterend', buy);
      buy.addEventListener('click', function () {
        if (atc.disabled || atc.hasAttribute('data-soldout')) { return; }
        run(buy, input.value, true);
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atc.hasAttribute('data-soldout')) {
          gotoNotify(cardLink && cardLink.getAttribute('href'));
          return;
        }
        run(atc, input.value, false);
      });
    });
  }

  function enhanceGrid() {
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card.getAttribute('data-ameya')) { return; }
      var content = card.querySelector('.product-card__content');
      if (!content) { return; }
      var q = card.querySelector('quick-add-component');
      var idIn = q && q.querySelector('input[name=id]');
      var badge = card.querySelector('.product-badges');
      var soldBadge = !!badge && (badge.textContent || '').toLowerCase().indexOf('sold out') > -1;
      if (!idIn && !soldBadge) { return; }
      card.setAttribute('data-ameya', '1');
      var addBtn = q && q.querySelector('button[name=add]');
      var sold = soldBadge || !idIn || !addBtn || addBtn.disabled || (addBtn.textContent || '').toLowerCase().indexOf('sold') > -1;
      var wrap = document.createElement('div');
      wrap.className = 'ameya-cardbtns';
      if (sold) {
        var pl = card.querySelector('a[href*="/products/"]');
        var notify = document.createElement('a');
        notify.className = 'ameya-btn ameya-cardatc ameya-cardnotify';
        notify.textContent = 'Notify me';
        notify.href = (pl ? String(pl.getAttribute('href')).split('#')[0].split('?')[0] : '') + '#notify';
        notify.addEventListener('click', function (e) { e.stopPropagation(); });
        wrap.appendChild(notify);
        content.appendChild(wrap);
        return;
      }
      var atc = mk('Add to Cart', 'ameya-btn ameya-cardatc');
      var buy = mk('Buy now', 'ameya-btn ameya-btn--outline ameya-cardbuy');
      atc.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); run(atc, idIn && idIn.value, false); });
      buy.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); run(buy, idIn && idIn.value, true); });
      wrap.appendChild(atc);
      wrap.appendChild(buy);
      content.appendChild(wrap);
    });
  }

  function autoCheckout() {
    if (!isCart) { return; }
    var t = 0;
    try { t = parseInt(sessionStorage.getItem('ameya_autocheckout') || '0', 10); sessionStorage.removeItem('ameya_autocheckout'); } catch (e) {}
    if (!t || Date.now() - t > 30000) { return; }
    var tries = 0;
    (function go() {
      var b = document.querySelector('#checkout') || document.querySelector('button[name=checkout]');
      if (b && !b.disabled) { setTimeout(function () { b.click(); }, 900); }
      else if (tries++ < 20) { setTimeout(go, 300); }
    })();
  }

  var queued = false;
  function enhance() { queued = false; enhanceRails(); enhanceGrid(); }
  function schedule() {
    if (queued) { return; }
    queued = true;
    (window.requestAnimationFrame || setTimeout)(enhance, 0);
  }

  function init() {
    buildFab();
    enhance();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    autoCheckout();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  window.addEventListener('pageshow', function (e) { if (e.persisted) { refresh(); } });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { refresh(); } });
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-ameya-buynow]') : null;
    if (b) { try { sessionStorage.setItem('ameya_autocheckout', String(Date.now())); } catch (x) {} }
  }, true);

  // Any link to the cart opens the slide-in cart instead of leaving the page
  document.addEventListener('click', function (e) {
    if (isCart || isCheckout || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.closest('#cart-drawer') || a.hasAttribute('data-ameya-buynow')) { return; }
    var path = '';
    try { path = new URL(a.getAttribute('href'), location.origin).pathname.replace(/\/+$/, ''); } catch (x) { return; }
    if (path !== '/cart') { return; }
    if (openDrawer()) { e.preventDefault(); }
  });

  // Product page: add to cart without leaving the page, then show the slide-in cart
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) { return; }
    if (form.closest('.ameya-card') || form.closest('product-form-component')) { return; }
    var act = window.Shopify && Shopify.actions && Shopify.actions.updateCart;
    var d = drawerEl();
    if (isCart || !act || !d || typeof d.open !== 'function') { return; }
    var idEl = form.querySelector('[name=id]');
    if (!idEl || !idEl.value) { return; }
    var qtyEl = form.querySelector('[name=quantity]');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]');
    if (btn && btn.disabled) { return; }
    var label = btn ? btn.textContent : '';
    function reset() { if (btn) { btn.textContent = label; btn.disabled = false; } }
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    act({ lines: [{ merchandiseId: String(idEl.value), quantity: qty }] }).then(function (res) {
      var errs = res && res.userErrors;
      if (errs && errs.length) { throw new Error(errs[0].message || 'add failed'); }
      if (btn) { btn.textContent = (res && res.warnings && res.warnings.length) ? 'Already in cart' : 'Added to cart'; }
      setTimeout(reset, 1700);
    }).catch(function () {
      if (btn) { btn.textContent = 'Try again'; }
      setTimeout(reset, 1800);
    });
  }, true);

  // Keep the bag count right after any cart change, and open the slide-in cart after an add
  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (!e || !e.promise) { return; }
    e.promise.then(function (res) {
      refresh();
      if (isCart || e.action !== 'add') { return; }
      if (res && res.detail && res.detail.didError) { return; }
      openDrawer();
    }).catch(function () {});
  });
})();